export default __webpack_public_path__ + "static/media/icon_error500.2452f2f6.svg";